<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("love.menu.form_styles") }} </template>
        <template #sidebarMain>
            <div>
                <CardToggle :title="$t('shared.colors.title')">
                    <div class="space-y-5">
                        <p class="ct-text">
                            {{ $t("shared.colors.info") }}
                        </p>
                        <template v-if="wall.formColors">
                            <FormInputColor
                                :title="$t('shared.colors.background_left')"
                                v-model="wall.formColors.background"
                                :tooltip="$t('shared.select_color_info')"
                            />
                            <FormInputColor
                                :title="$t('shared.colors.text_left')"
                                v-model="wall.formColors.text"
                                :tooltip="$t('shared.select_color_info')"
                            />

                            <FormInputColor
                                :title="$t('shared.colors.button_background')"
                                v-model="wall.formColors.buttonBackground"
                                :tooltip="$t('shared.select_color_info')"
                            />
                            <FormInputColor
                                :title="$t('shared.colors.button_text')"
                                v-model="wall.formColors.buttonText"
                                :tooltip="$t('shared.select_color_info')"
                            />
                        </template>
                    </div>
                </CardToggle>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { CardToggle } from "@easy/ui/cards";
import { FormInputColor } from "@easy/ui/forms";
import { mapState, mapActions } from "vuex";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    name: "MenuStyles",
    components: {
        CardToggle,
        FormInputColor,
        PageSidebar,
        cSaveButton,
    },
    computed: {
        ...mapState({
            googleFonts: (f) => f.googleFonts.map((label) => ({ label, value: label })),
        }),
        ...mapState("love", ["wall", "hasChanges"]),
    },
    async mounted() {
        await this.getFonts();
    },
    methods: {
        ...mapActions(["getFonts"]),
        ...mapActions("love/projects", ["saveSnapshot"]),
    },
};
</script>
